/**
 * Whether saving `next` could DELETE recordings: the retention sweep runs
 * hourly and applies a lowered window retroactively, irreversibly.
 *
 * - A number below the current effective value: yes.
 * - `null` (back to the platform default) from a custom value: treated as yes.
 *   The client does not know the platform default (only the API does), and it
 *   is 3 days out of the box — the lowest sensible setting — so "reset" is
 *   usually a lowering. Asking once too often is cheap; deleting is not.
 * - Anything else (raising, or no change): no.
 */
export function isRetentionLowering(
    currentDays: number,
    currentIsDefault: boolean,
    next: number | null,
): boolean {
    if (next === null) return !currentIsDefault;
    return next < currentDays;
}
